import { EventEmitter } from '@angular/core';

import * as _ from 'lodash';
import { Subscription } from 'rxjs';

import { ToastService } from '../toast.service';

export class Toast {
  constructor(
    private _settings: ToastSettings,
    private _service: ToastService
  ) {
    this.id = this._settings.id;
    this.message = this._settings.message;
    this.duration = this._settings.duration;
    this.show_close_button = this._settings.show_close_button;
    this.close_button_text = this._settings.close_button_text;
  }

  public onShow: EventEmitter<void> = new EventEmitter();
  public onShown: EventEmitter<void> = new EventEmitter();
  public onHide: EventEmitter<void> = new EventEmitter();
  public onHidden: EventEmitter<void> = new EventEmitter();

  private _id: number;
  private _message: ToastStringFunction | string;
  private _duration = 5000;
  private _close_behavior: ToastCloseBehavior = 'close';
  private _show_close_button = true;
  private _close_button_text: ToastStringFunction | string;

  private _visible = false;

  public get visible(): boolean { return this._visible; }

  public get id(): number { return this._id; }
  public set id(value: number) { this._id = value; }

  public get message(): ToastStringFunction | string {
    let message = null;

    if (_.isString(this._message)) {
      message = this._message;
    } else if (_.isFunction(this._message)) {
      message = (<ToastStringFunction>this._message)();
    }

    return message || null;
  }
  public set message(value: ToastStringFunction | string) { this._message = value; }

  public get duration(): number { return this._duration; }
  public set duration(value: number) { this._duration = _.isNumber(value) ? value : 5000; }

  public get close_behavior(): ToastCloseBehavior { return this._close_behavior; }
  public set close_behavior(value: ToastCloseBehavior) { this._close_behavior = value ? value : 'close'; }

  public get show_close_button(): boolean { return this._show_close_button; }
  public set show_close_button(value: boolean) { this._show_close_button = _.isBoolean(value) ? value : true; }

  public get close_button_text(): ToastStringFunction | string {
    if (!this.show_close_button) { return null; }

    let text = null;

    if (_.isString(this._close_button_text)) {
      text = this._close_button_text;
    } else if (_.isFunction(this._close_button_text)) {
      text = (<ToastStringFunction>this._close_button_text)();
    }

    return text ? text : 'OK';
  }
  public set close_button_text(value: ToastStringFunction | string) { this._close_button_text = value; }

  public show() {
    if (this._visible) { return; }

    setTimeout(() => {
      this._visible = true;
      this.onShow.emit();
    });
  }

  public hide() {
    if (!this._visible) { return; }

    this._visible = false;
  }

  public destroy() {
    if (this._visible) {
      const subscription: Subscription = this.onHidden.subscribe(() => {
        subscription.unsubscribe();
        this._service.destroy(this.id);
      });

      this.hide();
    }
  }

}

export interface ToastSettings extends ToastData {
  id: number;
}

export interface ToastData {
  message: ToastStringFunction | string;
  duration?: number;
  close_behavior?: ToastCloseBehavior;
  show_close_button?: boolean;
  close_button_text?: ToastStringFunction | string;
}

export type ToastCloseBehavior = 'close' | 'dismiss';

export type ToastStringFunction = () => string;
